<app-modal-shell
  [isOpen]="aberto"
  [title]="titulo"
  [panelClass]="'max-w-[32rem] w-full px-2 sm:px-0'"
  [bodyClass]="'p-4'"
  [closeOnBackdropClick]="false"
  (fechado)="fechar.emit()">
  <div headerContent class="text-xs text-gray-500 dark:text-gray-400 m-1">
    Aluno(a): {{ nomeAluno }}
  </div>
  <div class="space-y-3">
    <div>
      <label class="mb-1 block text-sm font-medium text-gray-700 dark:text-gray-200">Descrição da avaliação</label>
      <textarea
        [ngModel]="texto"
        (ngModelChange)="onTextoChange($event)"
        [readonly]="readonly"
        maxlength="16000"
        rows="8"
        class="w-full rounded-xl border border-gray-300 dark:border-gray-600 bg-white dark:bg-gray-900 px-3 py-2 text-sm text-gray-900 dark:text-gray-100"
        placeholder="Digite aqui a avaliação"></textarea>
    </div>

    <div class="flex items-center justify-end text-xs text-gray-500 dark:text-gray-400">
      <span>{{ texto.length }}/16000</span>
    </div>

    <div class="flex justify-end gap-2 pt-2">
      <button type="button" (click)="salvar.emit()" [disabled]="readonly" class="rounded-md bg-[#4b5bdc] hover:bg-[#4252cf] disabled:opacity-50 text-white px-4 py-2.5 text-sm font-medium">Salvar</button>
      <button type="button" (click)="fechar.emit()" class="rounded-md border border-gray-200 dark:border-gray-700 bg-white dark:bg-gray-900 px-4 py-2.5 text-sm font-medium text-gray-700 dark:text-gray-200">Cancelar</button>
    </div>
  </div>
</app-modal-shell>
